import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useSupplierStockStore = defineStore('supplierStock', {
  state: () => ({}),
  getters: {},
  actions: {
    async action_getMenu() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2046,
      };
      //console.log('action_getPrices Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getPrices Success: ', response);
          return {
            result: true,
            data: response.data.stocks
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_removeMenu(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2048,
        "stock": payload
      };
      console.log('action_removeMenu Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_removeMenu Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_addMenu(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2047,
        "stock": payload
      };
      console.log('action_addMenu Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_addMenu Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    }
  }
});
